import React, { useCallback, useContext, useReducer } from 'react'
import { curry } from 'ramda'
import { State, moveTo, setValue } from '@btime/state-monad'

import { Reducer } from '../../../../utils/reducer/chain'
import { generateContext } from '@btime/react-contexts'
import { handleState } from '../../../../utils/reducer/basicStateHandler'
import { useOnUnload } from '@btime/react-hooks'
import { useSegmentationFormattedFormData } from './formatSegmentationFormData'

const { StateContext, ActionsContext, Provider } = generateContext()
export const useSegmentationForm = () => useContext(StateContext)
export const useSegmentationFormActions = () => useContext(ActionsContext)

export const useIsEditing = () => {
  const segmentation = useSegmentationForm()
  return !!segmentation && !!segmentation.id
}

const initialState = {
  name: '',
  userGroups: [],
  checklistTypes: [],
  placeLevels: [],
  assets: []
}

const SET_VALUE = 'SET_VALUE'

const reducer = (state, action) =>
  Reducer(state, action)
    .map(
      handleState(SET_VALUE, (state, action) => {
        const { field, value } = action.payload

        return State.of({ ...state, touched: true })
          .map(moveTo(field))
          .map(setValue(value))
          .fold()
      })
    )

    .foldState()

const Form = ({ children }) => {
  const segmentationFormData = useSegmentationFormattedFormData()
  const [state, dispatch] = useReducer(reducer, { ...initialState, ...(segmentationFormData || {}) })
  useOnUnload({ condition: !!state.touched })

  const handleChange = useCallback(
    curry((field, value) => dispatch({ type: SET_VALUE, payload: { field, value } })),
    [dispatch]
  )

  return (
    <Provider
      state={state}
      actions={{
        handleChange
      }}
    >
      {children}
    </Provider>
  )
}

export default Form
